import { Alert, AlertTitle, Box, Chip, Container, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { DateTime, Interval } from "luxon";
import { useEffect, useState } from "react";
import { Employee } from "../../types/Employee";
import { Vacation } from "../../types/Vacation";
import { queryEmployee } from "../../utils/queryEmployee";
import { ChipIcon, ChipColor } from '../ChipUtils';

interface VacationRequestProps {
  vacation?: Vacation;
};
export const VacationRequestInfoBox = (props: VacationRequestProps) => {
  const { vacation } = props;
  const [employee, setEmployee] = useState<Employee>();

  let tenured = "0 year";
  if (employee) {
    const dateHired = DateTime.fromFormat(employee.dateHired, 'yyyyMMdd');
    const dateNow = DateTime.now();
    const interval = Interval.fromDateTimes(dateHired, dateNow);
    tenured = interval.length('years').toFixed(2) + ' years';
  }

  useEffect(() => {
    if (vacation) {
      queryEmployee(vacation.idNumber).then((e) => {
        setEmployee(e);
      });
    }
  }, []);
  
  if (!vacation) {
    return null;
  }

  return (
    <Container disableGutters>
      <Box>
        <TableContainer>
          <Table size="small">
            <TableBody>
              <TableRow>
                <TableCell width={250}>Id Number</TableCell>
                <TableCell>{vacation.idNumber}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell width={250}>Name</TableCell>
                <TableCell>{vacation.name}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={2}>
                  <Alert variant="outlined" severity="info">
                    <AlertTitle>Request Info</AlertTitle>
                    <Stack>
                      <div>
                        Requested Start Date — <strong>{DateTime.fromFormat(vacation.requestDateStart, 'yyyyMMdd').toFormat('MMMM dd, yyyy')}</strong>
                      </div>
                      <div>
                        Requested End Date — <strong>{DateTime.fromFormat(vacation.requestDateEnd, 'yyyyMMdd').toFormat('MMMM dd, yyyy')}</strong>
                      </div>
                    </Stack>
                  </Alert>
                </TableCell>
              </TableRow>
              {/* <TableRow>
                <TableCell width={250}>Vacation Request Start Date</TableCell>
                <TableCell>{DateTime.fromFormat(vacation.requestDateStart, 'yyyyMMdd').toFormat('MMMM dd, yyyy')}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell width={250}>Vacation Request End Date</TableCell>
                <TableCell>{DateTime.fromFormat(vacation.requestDateEnd, 'yyyyMMdd').toFormat('MMMM dd, yyyy')}</TableCell>
              </TableRow> */}
              <TableRow>
                <TableCell width={250}>Vacation Start Date</TableCell>
                <TableCell>{DateTime.fromFormat(vacation.dateStart, 'yyyyMMdd').toFormat('MMMM dd, yyyy')}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell width={250}>Vacation End Date</TableCell>
                <TableCell>{DateTime.fromFormat(vacation.dateEnd, 'yyyyMMdd').toFormat('MMMM dd, yyyy')}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell width={250}>Date Requested</TableCell>
                <TableCell>{vacation.dateRequested ? DateTime.fromISO(vacation.dateRequested).toFormat('MMMM dd, yyyy') : ''}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell width={250}>Tenure</TableCell>
                <TableCell>{tenured}</TableCell>
              </TableRow>
              <TableRow sx={{
                '&:last-child td, &:last-child th': { border: 0 } 
              }}>
                <TableCell width={250}>Request Status</TableCell>
                <TableCell>
                  <Chip 
                    icon={ChipIcon(vacation.requestStatus!)} 
                    label={vacation.requestStatus} 
                    color={ChipColor(vacation.requestStatus!)}
                    variant="outlined" />
                  </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Container>
  );
};